<template>
  <div class="">
    <button class="btn btn-primary mr-1 rounded-pill">میزان اعتبار: {{ charge }}</button>
  </div>
</template>

<script>
export default {
  name: "SmsCharge",
  data() {
    return {
      charge: null
    }
  },
  methods: {},
  async mounted() {
    await this.$store.dispatch('Sms/getSmsAuthorization')

    let req = await this.$store.dispatch('Sms/getSmsCharge');
    this.charge = req.data.data;
  }
}
</script>

<style scoped>

</style>